module.exports = __webpack_public_path__ + "img/cancun-bay-activities.98cb4cec.jpg";